import { ExternalLink, Reply } from 'lucide-react';
import { fillTemplate } from '../../utils/whatsapp';
import ChatBubble from './ChatBubble';
import PhoneFrame from './PhoneFrame';
import { whatsappTheme } from './whatsappTheme';

const { colors } = whatsappTheme;

const nowLabel = () => new Date().toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });

/**
 * Preview only: these rows are plain divs with role="presentation", never links or buttons, so an
 * admin cannot navigate or trigger anything by clicking them.
 */
const TemplateButtons = ({ buttons }) =>
  buttons.map((button, index) => (
    <div
      key={`${button.text}-${index}`}
      data-testid="template-button"
      role="presentation"
      className="mt-[2px] flex w-full select-none items-center justify-center gap-2 rounded-[7.5px] px-3 py-[10px] text-[14.2px] font-medium leading-none shadow-[0_1px_0.5px_rgba(11,20,26,0.13)]"
      style={{ backgroundColor: colors.incomingBubble, color: colors.link }}
    >
      {button.type === 'URL' ? (
        <ExternalLink aria-hidden="true" className="h-4 w-4 shrink-0" />
      ) : (
        <Reply aria-hidden="true" className="h-4 w-4 shrink-0" />
      )}
      {button.text}
    </div>
  ));

/**
 * The exact message a customer sees for a template. `{{n}}` becomes params[n-1]; a missing param is
 * an empty string (never raw braces). Header text gets the same substitution. Nothing is highlighted.
 * @param {{template: {header_text?: string, body?: string, footer_text?: string, buttons?: {type?: string, text?: string, url?: string}[]}, params?: string[], businessName?: string}} props
 */
const TemplatePreview = ({ template, params = [], businessName = 'KAAY' }) => {
  const { header_text: header, body, footer_text: footer, buttons = [] } = template || {};
  return (
    <PhoneFrame title={businessName}>
      <ChatBubble
        direction="in"
        tail
        time={nowLabel()}
        below={buttons.length > 0 ? <TemplateButtons buttons={buttons} /> : null}
      >
        {header && (
          <div data-testid="template-header" className="mb-1 font-bold">
            {fillTemplate(header, params)}
          </div>
        )}
        <div data-testid="template-body" className="whitespace-pre-wrap break-words">
          {fillTemplate(body, params)}
        </div>
        {footer && (
          <div data-testid="template-footer" className="mt-1 text-[13px]" style={{ color: colors.textSecondary }}>
            {footer}
          </div>
        )}
      </ChatBubble>
    </PhoneFrame>
  );
};

export default TemplatePreview;
